function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 17,
  cy: 4.5,
  rx: 3.5,
  ry: 3.5,
  stroke: "#11A1FD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.392 7.03867C26.8716 6.93244 26.3303 7.03844 25.8884 7.33312C25.4465 7.6278 25.1406 8.08675 25.0387 8.608C24.6931 10.3646 23.01 11.5253 21.2453 11.224L10.3826 9.66667C7.05508 9.13578 3.87547 11.2422 3.06665 14.5133C2.93755 15.0279 3.01814 15.5726 3.2907 16.0277C3.56326 16.4828 4.00545 16.811 4.51998 16.94C4.67966 16.9795 4.8435 16.9996 5.00798 17C5.91968 16.9934 6.71149 16.371 6.93332 15.4867C7.23741 14.2064 8.48891 13.3869 9.78398 13.62L12.3573 13.9893L10.6667 19.8773C10.4837 20.6846 9.81989 21.2942 8.99998 21.408L4.71465 22.02C3.62113 22.1765 2.8615 23.1898 3.01798 24.2833C3.17446 25.3769 4.18779 26.1365 5.28132 25.98L9.56665 25.3693C11.6686 25.0797 13.4583 23.6951 14.2667 21.7333L15.1507 21.9867C16.1017 22.2523 16.7126 23.177 16.584 24.156L16.0107 28.756C15.9036 29.4739 16.1939 30.1934 16.7691 30.636C17.3444 31.0787 18.1142 31.1749 18.7807 30.8875C19.4472 30.6001 19.9057 29.9741 19.9787 29.252L20.5533 24.6547C20.9386 21.7146 19.1074 18.9374 16.2533 18.1333L15.4013 17.8907L16.3613 14.5653L20.652 15.18C24.5273 15.7961 28.1968 13.2395 28.9613 9.39067C29.1771 8.3079 28.4746 7.25512 27.392 7.03867Z",
  stroke: "#11A1FD",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.21a586f997ed11d7282f2d5437f7b6c5.svg";
export { ForwardRef as ReactComponent };